import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { IconModule } from '../icon/icon-module';
import { ErrorBoxComponent } from './error-box.component';

@NgModule({
  declarations: [ErrorBoxComponent],
  imports: [CommonModule, PipesModule, IconModule],
  exports: [ErrorBoxComponent],
})
export class ErrorBoxModule {}
